export const OPEN_MI_CUSTOM_DATE_RANGE_MODAL = 'OPEN_MI_CUSTOM_DATE_RANGE_MODAL';
export const CLOSE_MI_CUSTOM_DATE_RANGE_MODAL = 'CLOSE_MI_CUSTOM_DATE_RANGE_MODAL';

function openCustomDateRangeModal() {
  return {
    type: OPEN_MI_CUSTOM_DATE_RANGE_MODAL,
    isDateRangePickerShown: true
  };
}

function closeCustomDateRangeModal(fromDate, toDate) {
  return {
    type: CLOSE_MI_CUSTOM_DATE_RANGE_MODAL,
    isDateRangePickerShown: false,
    dateRangeFrom: fromDate,
    dateRangeTo: toDate
  };
}

export function showCustomDateRangeModal() {
  return (dispatch) => {
    dispatch(openCustomDateRangeModal());
  };
}

export function hideCustomDateRangeModal(fromDate, toDate) {
  return (dispatch) => {
    dispatch(closeCustomDateRangeModal(fromDate, toDate));
  };
}
